import { Button, Drawer } from 'antd';
import CustomModal from '../../../../components/CustomModal';
import { InviteIcon } from '../../../../components/icons/InviteIcon';
import { UpdateContainer } from '../../../../components/dashboard/sales/UpdateStatus';
import { theme } from '../../../../components/theme/theme';
import { useMediaQuery } from '@mui/material';
import { TeamMembers } from '../../../../interfaces/User';
import { Dispatch, SetStateAction } from 'react';

interface DisableUserModalProps {
    userEmail: string;
    open: boolean;
    onClose: () => void;
    loading: boolean;
    handleDisable: () => void;
    setSelectedUser: Dispatch<SetStateAction<TeamMembers | null>>;
}

const DisableUserModal = ({
    userEmail,
    open,
    onClose,
    loading,
    handleDisable,
    setSelectedUser
}: DisableUserModalProps) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const renderContent = () => (
        <UpdateContainer maxWidth='450px' className='mx-auto px-8 py-6 w-full'>
            <InviteIcon />
            <h2 className='pt-6 mb-2 text-[18px] font-bold text-ebony'>
                Disable Team Member
            </h2>
            <h5 className='leading-7 text-[18px] text-paleSky'>
                By doing this, <span className='font-bold'>{userEmail}</span>{' '}
                will no longer have a role in your organization. Do you want to
                continue?
            </h5>
            <div className='cta-buttons mt-6 flex justify-between gap-4'>
                <Button
                    className='btn-1'
                    onClick={() => {
                        setSelectedUser(null);
                        onClose();
                    }}
                >
                    Cancel
                </Button>
                <Button
                    className='btn-3'
                    loading={loading}
                    onClick={handleDisable}
                >
                    Disable
                </Button>
            </div>
        </UpdateContainer>
    );

    return isMobile ? (
        <Drawer
            placement='bottom'
            closable={false}
            onClose={() => {
                setSelectedUser(null);
                onClose();
            }}
            open={open}
            height='45vh'
            className='!bg-white !rounded-t-xl pt-6'
        >
            {renderContent()}
        </Drawer>
    ) : (
        <CustomModal
            maxWidth='max-content'
            open={open}
            onClose={() => {
                setSelectedUser(null);
                onClose();
            }}
            title=''
            hideCloseIcon
        >
            {renderContent()}
        </CustomModal>
    );
};

export default DisableUserModal;
